import React from 'react'
import { connect } from 'react-redux'
import withTranslation from 'next-translate/withTranslation'
import { Page, PageHeader, AddPageContent } from '../src/ui'
import { CategoriesList } from '../src/modules/categories/components'
import { fetchCategories } from '../src/modules/categories/actions'
import { getPageMetaTags } from '../src/modules/common/selectors'
import initialState from '../src/modules/redux/initialState'
import { deepCopy } from '../src/utils'
import config from '../src/config/config.json'
import translations from '../public/data/translations.json'

class categories extends React.Component {
  static async getInitialProps({ store, query }) {
    const targetPage = query.targetPage

    console.log('categories query', query)

    await store.dispatch(fetchCategories({ locale: query?.locale?.toUpperCase() || 'ME' }))

    const pageMetaTags = getPageMetaTags(store.getState())

    const findPage = pageMetaTags.find(item => item.page === '/categories')

    return {
      title: findPage ? findPage.title : `${config.pages.categories.title} | ${config.pages.defaultTitle}`,
      targetPage,
      state: categories.getPageState(store)
    }
  }

  static getPageState(store) {
    const state = deepCopy(initialState)
    if (store) {
      const currentState = store.getState()

      state.user.auth.isAuthorized = currentState.user.auth.isAuthorized
      state.user.profile.error = currentState.user.profile.error
      state.user.profile.info = currentState.user.profile.info
      state.user.profile.favouriteAds = currentState.user.profile.favouriteAds
      state.user.profile.savedFilters = currentState.user.profile.savedFilters
      state.user.profile.favouriteProfiles = currentState.user.profile.favouriteProfiles
      state.user.profile.priceTypes = currentState.user.profile.priceTypes
      state.user.listSidebar = currentState.user.listSidebar

      state.common.transitions = currentState.common.transitions
      state.common.router = currentState.common.router
      state.common.is404 = false
      state.common.isMobileDevice = currentState.common.isMobileDevice
      state.common.userTypes = currentState.common.userTypes
      state.common.pageMetaTags = currentState.common.pageMetaTags
      state.common.pageMetaTagsSingle = currentState.common.pageMetaTagsSingle

      state.groups.elements = currentState.groups.elements

      state.categories.elements = currentState.categories.elements
      state.categories.bySeo = currentState.categories.bySeo
      state.categories.similarWords = currentState.categories.similarWords

      state.ads.detail.reportTypes = currentState.ads.detail.reportTypes
      state.ads.detail.registrationFormulas = currentState.ads.detail.registrationFormulas

      state.form = currentState.form
    }
    return state
  }

  render() {
    const { targetPage, i18n } = this.props

    const { t, lang } = i18n

    const locale = lang?.toUpperCase() || 'ME'

    console.log('i18n', translations.pretragaOglasa[locale])

    let baseHref = '/category'
    let baseAs = '/'

    if (targetPage === translations.pretragaOglasa[locale]) {
      baseHref = '/mobileAdFilter'
      baseAs = `/${translations.pretragaOglasa[locale]}/`
    }

    return (
      <Page>
        <PageHeader>{t('common:categories_page_header')}</PageHeader>
        <AddPageContent
          title={t('common:categories_page_header')}
          description={t('common:categories_page_description')}
        >
          <CategoriesList
            placeholder={t('common:categories_page_placeholder')}
            baseHref={baseHref}
            baseAs={baseAs}
          />
        </AddPageContent>
      </Page>
    )
  }
}

export default withTranslation(categories)
